/*
 * File: MeetingfulScript.js
 * Project: reports
 * Created Date: Monday July 30th 2018
 * Author: Austin Smith
 * -----
 * Last Modified: Friday, 10th August 2018 10:30:21 am
 * Modified By: Austin Smith (austin.smith918@yahoo.com>)
 * -----
 * Copyright (c) 2018 Teaming
 */

// qTip2
import "qtip2";
import "qtip2/dist/jquery.qtip.min.css";



// WEBPACK FOOTER //
// ./src/lib/MeetingfulScript.js